const word_limit_tiny = (el, wordLen = 1000) => {
    const len = el.split(/[\s]+/);

    if (len.length > wordLen) {
        tinymce.activeEditor.setMode('readonly');
    }
};

const word_limit = (el, wordLen) => {
    const len = el.val().split(/[\s]+/);
    if (len.length > wordLen) {
        if (event.keyCode === 46 || event.keyCode === 8) {  // Allow backspace and delete buttons
        } else if (event.keyCode < 48 || event.keyCode > 57) {  //all other buttons
            event.preventDefault();
        }
    }
};


$(document).on('keyup', '[data-char-limit]', (e) => {
    const el = $(e.currentTarget);
    const wrapper = el.parent().find('.char-limit-status-wrapper');
    const display = wrapper.find('.char-limit-status');
    const currentValueCount = $.trim(el.val()).length;
    const maxlimit = el.attr('data-char-limit');

    el.toggleClass('char-limit-reached', currentValueCount <= maxlimit);

    display.text(currentValueCount);

    wrapper.toggleClass('has-max-count', currentValueCount > maxlimit);
});


$(document).on('keyup', '[data-word-limit]', (e) => {
    const el = $(e.currentTarget);
    const wrapper = el.parent().find('.char-limit-status-wrapper');
    const display = wrapper.find('.char-limit-status');
    const maxlimit = el.attr('data-word-limit');
    const currentValueCount = $.trim(el.val()).split(/[\s]+/).length;

    el.toggleClass('char-limit-reached', currentValueCount <= maxlimit);
    display.text(currentValueCount);

    wrapper.toggleClass('has-max-count', currentValueCount > maxlimit);
});


export { word_limit, word_limit_tiny };